import React, { memo, useCallback, useState } from "react";
import { Button, Icon } from "uikit";

import Call from "../../../../services/Call";
import { downloadViaURL } from "../../../../utils/file";
import Player from "../../../../pages/MainPage/pages/Archives/tabs/CallsHistory/components/Content/components/Player";
import { StyledRow } from "../../../common";

const Record: React.FC<Record.Props> = memo(({ playSoundUrl }) => {
	const [showModal, setShowModal] = useState(false);
	const [isPlaying, setIsPlaying] = useState(false);

	const downloadSound = useCallback(() => {
		if (playSoundUrl) downloadViaURL(playSoundUrl, "Record");
	}, [playSoundUrl]);

	const handleOpen = useCallback(() => {
		setShowModal(true);
		setIsPlaying(true);
	}, []);

	const handleClose = useCallback(() => {
		setShowModal(false);
		setIsPlaying(false);
	}, []);

	return (
		<StyledRow gap="6px">
			<Button.Button
				disabled={!playSoundUrl}
				variant="secondary"
				icon={
					<Icon
						id={isPlaying ? "pause" : "order-modal-call-record"}
						size={18}
					/>
				}
				onClick={handleOpen}
			/>
			<Button.Button
				disabled={!playSoundUrl}
				onClick={downloadSound}
				variant="secondary"
				icon={<Icon id={"save"} size={18} />}
			/>
			{showModal && (
				<Player
					onClose={handleClose}
					setIsPlaying={setIsPlaying}
					src={playSoundUrl}
				/>
			)}
		</StyledRow>
	);
});

declare namespace Record {
	interface Props {
		playSoundUrl?: Call.Model["playSoundUrl"];
	}
}

export default Record;
